import * as React from 'react'
import styled from 'styled-components'

interface DropDownProps {
  items: { key; value: string; selected?: boolean }[]
  onSelect: (e) => void
  placeholder: string
  valid?: boolean
  clever?: boolean
}

let colorStyles = {
  'border': '#a7c9cd',
  'borderError': '#974353',
  'bg': '#d5e4e6'
}

const DropDown = (props: DropDownProps) => {
  const { items, onSelect, placeholder, valid , clever } = props
  if(clever){
    colorStyles = {
      'border': '#FBB07F',
      'borderError': '#974154',
      'bg': '#FDD7BF'
    }
  }
  return (
    <Wrapper valid={valid}>
      <i className='fas fa-chevron-down' />
      <CustomDropDown onChange={onSelect}>
        <option disabled selected value=''>
          {placeholder}
        </option>
        {items.map((i) => {
          return (
            <option value={i.key} selected={i.selected}>
              {i.value}
            </option>
          )
        })}
      </CustomDropDown>
    </Wrapper>
  )
}



const Wrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 0;
  border-bottom: 2px solid;
  line-height: 1.48;
  border-color: ${(props) => (props.valid ? colorStyles.border : colorStyles.borderError )};

  i {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &:hover {
    cursor: pointer;
  }
`
Wrapper.defaultProps = {
  valid: true
}

const CustomDropDown = styled.select`
  width: 100%;
  padding: 15px 0 15px 30px;
  border: none;
  border-radius: 0;
  background: ${(props) => (colorStyles.bg)};
  font-size: 15px;
  appearance: none;
  &:focus {
    outline: none;
  }
`

export default DropDown



// WEBPACK FOOTER //
// ./src/components/atoms/input/Dropdown.tsx